import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useDeletePrescrption, usePrescription } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import CreatePrescription from "./CreatePrescription";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  canWritePrescription,
  getCurrentUserRole,
} from "modules/utilities/utility";
import { Popconfirm } from "antd";

function PrescriptionTable({
  order,
  currentId,
  prescriptions,
  prescriptionData,
  oneLinerPrescription,
  currentPrescription,
  prescriptionsData = null,
  prescriptionId = null,
}) {
  const { setDeletPrescription } = useDeletePrescrption();
  const { fetchPrescriptionData } = usePrescription();
  const [editFlag, setEditFlag] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const [canEditUser, setCanEditUser] = useState(false);
  const editStatusFlag = ["shipping_pending", "pending_prescription"];
  const handleDeletePrescription = () => {
    setDeletPrescription(
      prescriptionData.id,
      fetchPrescriptionData,
      order.case_id,
      toast
    );
  };

  useEffect(() => {
    setCanEdit(editStatusFlag.includes(order?.status));
    if (canWritePrescription.includes(getCurrentUserRole())) {
      setCanEditUser(true);
    } else {
      setCanEditUser(false);
    }
  }, []);

  const handleEditPrescription = () => {
    setEditFlag(!editFlag);
  };

  return (
    <>
      <div className="border rounded p-2 m-2">
        <div style={{ display: "flex", alignItems: "center" }}>
          <h4 style={{ flex: "1" }}>
            Prescription for {currentId} written by{" "}
            {prescriptionData?.user?.first_name}
          </h4>
          {currentPrescription && (
            <div className="d-flex gap-2">
              <Button
                className={!canEdit || !canEditUser ? "disabled" : ""} // Apply the disabled class conditionally
                onClick={handleEditPrescription}
                disabled={!canEdit || !canEditUser}
              >
                Edit
              </Button>
              <Popconfirm
                title="Are you sure to delete?"
                placement="topLeft"
                onConfirm={handleDeletePrescription}
              >
                <Button
                  variant="danger"
                  className={!canEditUser ? "disabled" : ""} // Apply the disabled class conditionally
                  disabled={!canEdit || !canEditUser}
                >
                  Delete
                </Button>
              </Popconfirm>
            </div>
          )}
        </div>
        <div>
          {editFlag ? (
            <CreatePrescription
              order={order}
              prescriptionData={prescriptions}
              orderId={prescriptionId}
              dosages={prescriptions}
              editFlag={true}
            />
          ) : prescriptions && !editFlag ? (
            <div>
              <div className="d-flex border my-1 border rounded">
                <p className="flex-1 m-0 p-2 border">Medicine</p>
                <p className="flex-1 m-0 p-2 border">Dosage</p>
                <p className="flex-1 m-0 p-2 border">Notes</p>
              </div>
              {prescriptions.map((prescription, index) => {
                return (
                  <div
                    key={index}
                    className="d-flex border my-1 border rounded"
                  >
                    <p className="flex-1 m-0 p-2 border">
                      {prescription.Medicine}
                    </p>
                    <p className="flex-1 m-0 p-2 border">
                      {prescription.Dosage}
                    </p>
                    <p className="flex-1 m-0 p-2 border">
                      {prescription?.note}
                    </p>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="border rounded m-1 mt-3 ">
              <h3 className="p-2 border-bottom">
                {prescriptionData.user.first_name}
              </h3>
              <p className="p-2">{oneLinerPrescription}</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default PrescriptionTable;
